import { render, staticRenderFns } from "./editCharacter.vue?vue&type=template&id=3f678d85"
import script from "./editCharacter.vue?vue&type=script&lang=js"
export * from "./editCharacter.vue?vue&type=script&lang=js"
import style0 from "./editCharacter.vue?vue&type=style&index=0&id=3f678d85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports